export const validation = {
  maxQuoteChar: 250
}